export const M = {
  duration: 0.18,
  ease: [0.2, 0.8, 0.2, 1] as [number, number, number, number],
}
